import React from "react";
import { DatePicker } from "antd";

import dayjs from "../../../util/dayjs";
import fieldIcon from "./fieldIcons";

/* Stored as a naive `YYYY-MM-DDTHH:mm:ss` string — the same shape the native `datetime-local`
   input produced before this, so nothing downstream (the API, the list's date columns) had to
   change. Import the app's dayjs instance, not `dayjs`, or the calendar starts its week on
   Sunday in English (see `src/util/dayjs.js`). */
const FORMAT = "YYYY-MM-DDTHH:mm:ss";

export default function DateTimeField({ field, value, onChange }) {
  const parsed = value ? dayjs(value) : null;
  return (
    <DatePicker
      showTime
      prefix={fieldIcon(field)}
      value={parsed && parsed.isValid() ? parsed : null}
      onChange={next => onChange(field.name, next ? next.format(FORMAT) : "")}
    />
  );
}
